export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const backgroundImageLogin = require("../assets/Login.png");
export const PasswordVisible = require("../assets/password_visible.png");
export const PasswordInVisible = require("../assets/password_invisible.png");
export const logo = require("../assets/logo.png")
export const loginVideo = require("../assets/loginvideo.mp4")
export const newbackgroundImageLogin = require("../assets/LoginBack.jpg");

